import React from 'react';

import cn from 'classnames';

import { ICommentMessage } from '@entities/message/model/types';
import { Flex } from '@shared/ui';
import { ImageAttachments } from '@widgets/Comments/ui/Messages/MessageAttachments/ImageAttachments';
import { MessageAttachment } from '@widgets/Comments/ui/Messages/MessageAttachments/MessageAttachment';

import cls from './MessageAttachments.module.css';

interface IMessageAttachmentsProps {
    className?: string;
    imgAttachments?: ICommentMessage['images'];
    otherAttachments: ICommentMessage['files'];
}
export const MessageAttachments = ({
    className,
    imgAttachments,
    otherAttachments,
}: IMessageAttachmentsProps) => (
    <Flex
        className={cn(cls.MessageAttachments, className)}
        direction="column"
        gap={10}
        justify="start"
        align="start"
        fullWidth
    >
        {imgAttachments?.length > 0 && <ImageAttachments imgAttachments={imgAttachments} />}
        {/* {imgAttachments?.length > 0 && <Image src={imgAttachments[0]?.originalUrl} height={194} />} */}
        {otherAttachments?.length > 0 && (
            <Flex className={cls.OtherAttachments} direction="column" gap={10}>
                {otherAttachments?.map((attachment) => (
                    <MessageAttachment
                        key={attachment.id}
                        // key={attachment.id}
                        attachment={attachment}
                        attachments={otherAttachments}
                    />
                ))}
            </Flex>
        )}
    </Flex>
);
